import config from 'config';
import tmpl from './form.phtml';
import View from 'lib/View';
import * as repo from 'db/repositories';

export default View.extend({
	el: '#form',
	template: tmpl,

	events: {
		'submit form': 'onSubmit',
		'keyup textarea': 'removeInvalidFeedback',
		'change :input': 'removeInvalidFeedback',
		'render': 'scrollToInvalidFeedback',
	},


	setLatLng: function( latlng )
	{
		this.$("#"+this.model.cid+"_lat").val( latlng.lat );
		this.$("#"+this.model.cid+"_lng").val( latlng.lng );
	},


	render: function()
	{
		this.doRender({
			pond: this.model
		});
	},



	onSubmit: function( evt )
	{
		evt.preventDefault();

		var data = this.$('form').serializeJSON();
		this.$(':input, button').prop('disabled',true);

		if( _.has( data, 'lat' ) ) { data.lat = parseFloat( data.lat ); }
		if( _.has( data, 'lng' ) ) { data.lng = parseFloat( data.lng ); }

		// Enregistre les données en que le signalement soit pret ou pas
		this.model.set( data );
		if( !this.model.isValid() )
		{
			return this.render();
		}

		var self = this;

		// Vérification territoire (async Dexie + Turf)
		repo.getClosestZone( data ).then( function( zone )
		{
			if( !zone )
			{
				self.model.setErrors( { lat: "Le positionnement géographique ne semble pas être sur le territoire français" } );
				return self.render();
			}

			self.model._zone = zone;
			if( zone.get( 'id' ) )
			{
				self.model.set( 'zone_id', zone.get( 'id' ) );
			}

			self.model.set('todo','create');
			app.persistModel( self.model ).then( function()
			{
				app.commit();
				app.redirect( self.model.toUrl( 'pond/view' ) );
			} );
		} ).catch( function( err )
		{
			console.error( err );
			self.$(':input, button').prop('disabled', false);
		} );
	}

});
